import { ChangeDetectionStrategy, ChangeDetectorRef, Component,   Input } from '@angular/core';
import { BaseControlComponent } from "../base/base-control.component";
import { SelectorService } from '../base/selector.service';
@Component({
  // moduleId: module.id,
  selector: 'sepidz-color-picker',
  templateUrl: './sepidz-color-picker.component.html',
  styleUrls: ['./sepidz-color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SepidzColorPickerComponent extends BaseControlComponent<string>{
  isshow: boolean;
  orignalTextType: string = "text";
  cpToggle:boolean;
  ngAfterViewChecked() {
    super.ngAfterViewChecked();
    if (this.f[this.name].value || this.f[this.name].value !== undefined && this.f[this.name].value !== null) {
      this.isshow = true;
    }
  }
  show() {
    this.isshow = !this.isshow;
  }
  focusFunction() {
    this.isshow = true;
    if (document.getElementById(this.name))
      document.getElementById(this.name).focus();
  }
  focusOutFunction() {
    if (!this.f[this.name].value || this.f[this.name].value === '') {
      this.isshow = false;
    }
    this.cpToggle = false;
  }
  get Currentvalue()
  {
    return this.f[this.name].value;
  }
  @Input() checked: boolean = false;
  @Input() val: string
  @Input() autocomplete: string = "off";

   constructor(protected selectorService: SelectorService,protected cd: ChangeDetectorRef) {
    super(selectorService,cd);
  }

  onChange($event) {
    this.f[this.name].setValue($event);
    this.valueChange.emit($event);
  }
}
